import { useEffect, useRef } from "react";
import { useAuthCompat } from "../utils/clerkConfig";
import { trackEvent, AUTH_INTENT_STORAGE_KEY } from "../utils/analytics";

// Fires a GA "sign_up"/"login" event the moment Clerk's auth state flips
// from signed-out to signed-in. Mounted once at the app root so it catches
// the transition regardless of which flow completed it (password or SSO
// redirect, both of which land back on different pages).
function AnalyticsAuthTracker() {
  const { isLoaded, isSignedIn } = useAuthCompat();
  const previousSignedInRef = useRef(null);

  useEffect(() => {
    if (!isLoaded) {
      return;
    }

    const wasSignedIn = previousSignedInRef.current;
    previousSignedInRef.current = isSignedIn;

    // First observation after load establishes the baseline; an
    // already-authenticated page load/refresh must not count as a login.
    if (wasSignedIn === null || wasSignedIn === isSignedIn) {
      return;
    }

    if (!wasSignedIn && isSignedIn) {
      const intent = window.sessionStorage.getItem(AUTH_INTENT_STORAGE_KEY);
      trackEvent(intent === "sign_up" ? "sign_up" : "login", { method: "clerk" });
      window.sessionStorage.removeItem(AUTH_INTENT_STORAGE_KEY);
    }
  }, [isLoaded, isSignedIn]);

  return null;
}

export default AnalyticsAuthTracker;
